import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { PrimeNgModule } from "@primeng";
import { OfflineModule } from "@main/offline/offline.module";

import { GridComponent } from "./grid.component";
import { GridColumnTemplateDirective } from "./grid-template.directive";
import { GridEditingDialogComponent } from "./grid-editing-dialog.component";
import { GridImportDialogComponent } from "./grid-import-dialog.component";


@NgModule({
    declarations: [ GridComponent, GridColumnTemplateDirective, GridEditingDialogComponent, GridImportDialogComponent ],
    exports: [ GridComponent, GridColumnTemplateDirective ],
    imports: [
        CommonModule, RouterModule, FormsModule, ReactiveFormsModule,
        PrimeNgModule, OfflineModule
    ]
})
export class GridModule {}
